import {
  AutoAwesomeOutlined,
  CheckCircleOutline,
  FavoriteBorderOutlined,
  LocalShippingOutlined,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const AboutSectionTwo: React.FC = () => {
  const theme = useTheme();
  const { t: myTranslate } = useTranslation();

  const companyValues = [
    {
      icon: <CheckCircleOutline sx={{ fontSize: 32 }} />,
      title: myTranslate("about.values.customerFirst"),
      description: myTranslate("about.values.customerFirstDesc"),
      color: theme.palette.warning.main,
    },
    {
      icon: <AutoAwesomeOutlined sx={{ fontSize: 32 }} />,
      title: myTranslate("about.values.simplicity"),
      description: myTranslate("about.values.simplicityDesc"),
      color: theme.palette.warning.main,
    },
    {
      icon: <LocalShippingOutlined sx={{ fontSize: 32 }} />,
      title: myTranslate("about.values.reliability"),
      description: myTranslate("about.values.reliabilityDesc"),
      color: theme.palette.warning.main,
    },
    {
      icon: <FavoriteBorderOutlined sx={{ fontSize: 32 }} />,
      title: myTranslate("about.values.care"),
      description: myTranslate("about.values.careDesc"),
      color: theme.palette.warning.main,
    },
  ];

  return (
    <Box
      sx={{
        py: { xs: 3, md: 5 },
        backgroundColor: "transparent",
      }}
    >
      <Container maxWidth="xl">
        {/* Company Values */}
        <Box>
          <Box sx={{ textAlign: "center", mb: 6 }}>
            <Typography
              variant="h3"
              className="notranslate"
              translate="no"
              sx={{
                fontSize: { xs: "1.8rem", md: "2.5rem" },
                fontWeight: 800,
                color: theme.palette.text.primary,
                mb: 2,
              }}
            >
              {myTranslate("about.coreValues")}
            </Typography>
            <Typography
              variant="h6"
              className="notranslate"
              translate="no"
              sx={{
                color: theme.palette.text.secondary,
                maxWidth: 600,
                mx: "auto",
              }}
            >
              {myTranslate("about.coreValuesSubtitle")}
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {companyValues.map((value, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  sx={{
                    height: "100%",
                    textAlign: "center",
                    border: "none",
                    borderRadius: 3,
                    background: "white",
                    boxShadow: "none",
                    "&:hover": {
                      boxShadow: "none",
                    },
                    "&:hover .icon-avatar": {
                      transform: "scale(0.9)",
                    },
                  }}
                >
                  <CardContent sx={{ p: 4 }}>
                    <Avatar
                      className="icon-avatar"
                      sx={{
                        backgroundColor: `${value.color}15`,
                        color: value.color,
                        width: 64,
                        height: 64,
                        mx: "auto",
                        mb: 3,
                        transition: "transform 0.3s ease",
                      }}
                    >
                      {value.icon}
                    </Avatar>

                    <Typography
                      variant="h6"
                      className="notranslate"
                      translate="no"
                      sx={{
                        fontWeight: 700,
                        mb: 2,
                        color: theme.palette.text.primary,
                      }}
                    >
                      {value.title}
                    </Typography>

                    <Typography
                      variant="body2"
                      className="notranslate"
                      translate="no"
                      sx={{
                        color: theme.palette.text.secondary,
                        lineHeight: 1.6,
                      }}
                    >
                      {value.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default AboutSectionTwo;
